export default class Accordion {
    constructor() {
        this.init();
        this._resizeHandler(); 
    }

    init() {
        this._eventBind();
    }

    _eventBind() {
        document.querySelectorAll('.js-acc').forEach((accElm) => {
            const triggerElm = accElm.querySelector('.js-acc_trigger');

            triggerElm.addEventListener('click', () => {
                accElm.classList.toggle('-opened');
                const wrapper = triggerElm.nextElementSibling;
                this._toggleHeight(wrapper);
            });
        });
    }

    // 高さをトグルする
    _toggleHeight(wrapper) {
        const content = wrapper.querySelector('.js-acc_cont');
        const contentHeight = content.offsetHeight;

        if (parseInt(wrapper.style.height) === 0 || wrapper.style.height === '') {
            wrapper.style.height = `${contentHeight}px`;
        } else {
            wrapper.style.height = 0;
        }
    }

    // リサイズ時の高さ再計算
    _resizeHandler() {
        window.addEventListener('resize', () => {
            document.querySelectorAll('.js-acc').forEach((accElm) => {
                const wrapper = accElm.querySelector('.js-acc_trigger').nextElementSibling;
                const content = wrapper.querySelector('.js-acc_cont');

                if (accElm.classList.contains('-opened')) {
                    wrapper.style.height = `${content.offsetHeight}px`;
                }
            });
        });
    }
}
